(() => {
  angular.module('pims').filter('address', () => {
    'ngInject';

    return input => {
      let address = '';
      address += input.city || '';
      address += `, ${input.road}` || '';
      address += `, ${input.city}` || '';
      address += `, ${input.state}` || '';
      address += `, ${input.zip}` || '';
      return address;
    };
  });
})();